import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FlagGroup } from '../../shared/interfaces';

@Component({
  selector: 'app-group-picker',
  templateUrl: './group-picker.component.html',
  styleUrls: ['./group-picker.component.scss'],
})
export class GroupPickerComponent implements OnInit {
  resolver: (group: FlagGroup) => void;
  groups: FlagGroup[];
  chosen = new UntypedFormControl();
  @ViewChild('childModal', { static: true }) public childModal: ModalDirective;

  ngOnInit() {
    this.childModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });
  }

  ask(groups) {
    this.groups = groups;
    this.childModal.show();
    this.chosen.setValue(groups[0]);
    return new Promise<FlagGroup>(res => (this.resolver = res));
  }

  cancel() {
    this.resolver(null);
    this.childModal.hide();
  }

  ok() {
    this.resolver(this.chosen.value);
    this.childModal.hide();
  }
}
